/*
 * @Description: mrc_system_admin 的接口
 * @Autor: lwq
 * @Date: 2020-07-15 11:30:55
 * @LastEditors: lwq
 * @LastEditTime: 2020-07-15 11:40:06
 * @FilePath: \mrc-base-server-view\src\service\api\mrc_system_admin.js
 */
import http from '../httpConfig'

const table = 'mrbase_sys_users'

/**
 * @description: 管理员列表
 * @param {interface} /api/systemmanagement/list-user/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_list = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/list-user/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 管理员add
 * @param {interface} /api/systemmanagement/add-user/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_add = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/add-user/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 管理员update
 * @param {interface} /api/systemmanagement/update-user/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_update = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/update-user/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 管理员密码重置
 * @param {interface} /api/systemmanagement/update-reset-password/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_reset = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/update-reset-password/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 管理员账户禁用
 * @param {interface} /api/systemmanagement/update-disable-account/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_disabled = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/update-disable-account/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 管理员详情
 * @param {interface} /api/systemmanagement/find-user/v1
 * @return: 
 * @author: lwq
 */

export const mrc_admin_info = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/systemmanagement/find-user/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * @description: 功能权限列表
 * @param {interface} /api/role/list-function_role/v1
 * @return: 
 * @author: lwq
 */

export const func_list = (params = {}) => {
  params['~table~'] = 'mrbase_sys_role'
  return new Promise((resolve, reject) => {
    http.post('/api/role/list-function_role/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}